<template>
  <fieldset v-if="showPriceBox" id="order-total">
    <dl>
      <dt>Price</dt>
      <dd>{{ formatMoney(productPrice) }}</dd>
      <dt>Tax</dt>
      <dd>{{ formatMoney(tax) }}</dd>
      <dt v-if="showDiscount">Discount</dt>
      <dd v-if="showDiscount">{{ formatMoney(discount) }}</dd>
      <hr>
      <dt>Total</dt>
      <dd id="total-price">{{ formatMoney(total) }}</dd>
    </dl>
  </fieldset>
</template>

<script>

import { mapState } from 'pinia/dist/pinia'
import useBundleStore from '@/store/bundle'
import formatMoneyMixin from '@/mixins/formatMoneyMixin'

export default {
  name: 'TotalApp',
  mixins: [formatMoneyMixin],
  computed: {
    ...mapState(useBundleStore, ['total', 'productPrice', 'tax', 'discount']),
    showDiscount() {
      return this.discount > 0
    },
    showPriceBox() {
      return this.total > 0
    }
  }
}
</script>

<style lang="scss" scoped>
#total-price {
  font-weight: bold;
}
</style>
